const UUID_SEGMENT_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
const OBJECT_ID_SEGMENT_RE = /^[0-9a-f]{24}$/i
const HASH_LIKE_SEGMENT_RE = /^(?=.{16,}$)(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9_-]+$/

function shouldRedactSegment(segment) {
  if (!segment) {
    return false
  }

  return UUID_SEGMENT_RE.test(segment)
    || OBJECT_ID_SEGMENT_RE.test(segment)
    || HASH_LIKE_SEGMENT_RE.test(segment)
}

function normalizePathname(pathname = '/') {
  const normalizedPathname = pathname || '/'
  const prefixedPathname = normalizedPathname.startsWith('/')
    ? normalizedPathname
    : `/${normalizedPathname}`

  const segments = prefixedPathname
    .split('/')
    .map(segment => (shouldRedactSegment(segment) ? ':id' : segment))

  return segments.join('/') || '/'
}

export function normalizeTelemetryRoute(pathname = '/', search = '', {queryAllowlist = []} = {}) {
  const normalizedPath = normalizePathname(pathname)

  if (!Array.isArray(queryAllowlist) || queryAllowlist.length === 0) {
    return normalizedPath
  }

  const params = new URLSearchParams(search || '')
  const filtered = new URLSearchParams()

  queryAllowlist.forEach(key => {
    if (!params.has(key)) {
      return
    }

    params.getAll(key).forEach(value => {
      filtered.append(key, value)
    })
  })

  const query = filtered.toString()
  return query ? `${normalizedPath}?${query}` : normalizedPath
}

export function buildTelemetryRoute(location) {
  return normalizeTelemetryRoute(location?.pathname || '/', location?.search || '')
}
